<template>
  <div class="float-right boss-batch-select">
    <select
      v-model="selectedTargetOption"
      class="boss-input-select"
    >
      <option
        v-for="(targetOption ,i) in targetOptions"
        :key="i"
        :data-test="'target-option-' + targetOption.key"
        :value="targetOption"
      >
        {{ targetOption.optionLabel }}
      </option>
    </select>
    <span v-tooltip="{content: showTooltip ? '一括操作は1回あたり2,000件以内です。':''}">
      <button
        :disabled="isDisabled"
        class="boss-button boss-exe-button pega-button"
        data-test="action-button"
        @click="doAction()"
      >
        <span class="boss-exe-button-text">
          実行する
        </span>
      </button>
    </span>
    <!-- ▼一括更新モーダル -->
    <div
      id="bulk-update-modal"
      class="reveal boss-modal-container pega-modal-position"
      data-reveal
    >
      <h1
        class="boss-page-title boss-page-title-layout-title pega-mb-25"
        data-test="modal-title"
      >
        {{ selectedTargetOption.name }}の一括更新
      </h1>
      <div class="boss-layout boss-layout-center">
        <div class="pega-bulk-update-container">
          <div v-if="selectedTargetOption.key === 'phase_and_status'">
            <div data-test="modal-body-phase">
              選択したすべての応募者の選考フェーズ
            </div>
            <div>
              <select
                v-model="phaseId"
                data-test="input-select-phase"
                class="boss-input-select pega-mb-25"
              >
                <option
                  v-for="(itemOption ,i) in itemOptionMap.phases()"
                  :key="i"
                  :data-test="'item-option-phase-' + itemOption.id"
                  :value="itemOption.id"
                >
                  {{ itemOption.name }}
                </option>
              </select>

              <div data-test="modal-body-status">
                選択したすべての応募者の選考ステータス
              </div>
              <div>
                <select
                  v-model="statusId"
                  data-test="input-select-status"
                  class="boss-input-select"
                >
                  <option
                    v-for="(itemOption ,i) in itemOptionMap.phaseStatuses()"
                    :key="i"
                    :data-test="'item-option-status-' + itemOption.id"
                    :value="itemOption.id"
                  >
                    {{ itemOption.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div v-else>
            <div data-test="modal-body">
              選択したすべての応募者の{{ selectedTargetOption.name }}を
            </div>
            <select
              v-if="selectedTargetOption.key === 'responsible_staffs'"
              v-model="responsibleStaffId"
              data-test="input-select-responsible-staffs"
              class="boss-input-select"
            >
              <option
                v-for="(itemOption ,i) in itemOptionMap.responsibleStaffs()"
                :key="i"
                :data-test="'item-option-responsible-staff-' + itemOption.id"
                :value="itemOption.id"
              >
                {{ itemOption.name }}
              </option>
            </select>
            <textarea
              v-if="selectedTargetOption.key === 'remarks'"
              v-model="remarks"
              data-test="input-textarea-remarks"
              class="boss-send-textarea pega-textarea-resize-none"
            />
            <span>に</span>
          </div>
          <div>
            <button
              :disabled="isSelectionDisabled"
              class="float-center boss-button-center boss-button-large pega-button pega-mr-20"
              type="button"
              data-test="update-button"
              @click="update()"
            >
              更新する
            </button>
            <button
              class="float-center boss-button-center boss-button-large"
              type="button"
              data-test="cancel-button"
              @click="closeReveal()"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
      <button
        class="close-button boss-close-button boss-icon-cross"
        data-close
        aria-label="Close modal"
        type="button"
        @click="closeReveal()"
      />
    </div>
    <!-- ▲一括更新モーダル -->
  </div>
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { downloadCSV, downloadPDF } from '@/lib/download'
import Indicator from '@/lib/indicator'
import cartInAnimation from '@/lib/cartInAnimation'

export default {
  components: {},
  props: {
    entryIds: {
      type: Array,
      required: true
    },
    selectLimit: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      selectedTargetOption: _.head(definition.entryBulkUpdate),
      itemOptionMap: {
        phases: () => {
          return [...this.phases, { id: null, name: '更新しない' }]
        },
        phaseStatuses: () => {
          return [{ id: '', name: '-' }, ...this.allStatuses, { id: null, name: '更新しない' }]
        },
        responsibleStaffs: () => {
          return [{ id: '', name: '-' }, ...this.responsibles]
        }
      },
      responsibleStaffId: '',
      remarks: '',
      phaseId: null,
      statusId: null
    }
  },
  computed: {
    isPhaseChange () { return !(this.phaseId === null) },
    isStatusChange () { return !(this.statusId === null) }, // 空文字('')はtrueとさせたいためnullの時のみfalseにする
    isSelectionDisabled () {
      return this.selectedTargetOption.key === 'phase_and_status' && !this.isPhaseChange && !this.isStatusChange
    },
    parameter () {
      if (this.selectedTargetOption.key === 'phase_and_status') {
        return {
          entryIds: this.entryIds,
          isPhaseChange: this.isPhaseChange,
          phaseId: this.phaseId,
          isStatusChange: this.isStatusChange,
          statusId: this.statusId ? this.statusId : null // statusIdが空文字(=「−」を選択)はnullとして渡す(isStatusChangeはtrueにするので「更新しない」とは区別できる)
        }
      } else if (this.selectedTargetOption.key === 'responsible_staffs') {
        return {
          entryIds: this.entryIds,
          itemId: this.responsibleStaffId ? this.responsibleStaffId : null // statusIdが空文字(=「−」を選択)はnullとして渡す
        }
      } else {
        return {
          entryIds: this.entryIds,
          remarks: this.remarks
        }
      }
    },
    toastMessage () {
      if (this.isPhaseChange && !this.isStatusChange) {
        return '選考フェーズを更新しました'
      } else if (!this.isPhaseChange && this.isStatusChange) {
        return '選考ステータスを更新しました'
      } else {
        return `${this.selectedTargetOption.name}を更新しました`
      }
    },
    targetOptions () {
      return definition.entryBulkUpdate.filter(option => {
        if (option.permission === 'canPdfDownload') {
          return this.canPdfDownload
        } else if (option.permission === 'canSendMessage') {
          return this.canSendMessage
        } else {
          return true
        }
      })
    },
    isDisabled () {
      return _.isEmpty(this.entryIds) || this.entryIds.length > this.selectLimit
    },
    showTooltip () {
      return this.entryIds.length > this.selectLimit
    },
    ...mapGetters('settings', [
      'phases',
      'responsibles',
      'allStatuses',
      'fixedStatuses'
    ]),
    ...mapGetters([
      'canPdfDownload',
      'canSendMessage'
    ])
  },
  watch: {
    targetOptions: {
      handler (val) {
        this.$set(this, 'selectedTargetOption', _.head(val))
      },
      deep: true
    }
  },
  methods: {
    doAction () {
      if (this.selectedTargetOption.key === 'create_bulk_message') {
        this.$router.push({
          name: 'entryBulkMessage',
          params: { entryIds: this.entryIds }
        })
      } else if (this.selectedTargetOption.key === 'csv_download') {
        downloadCSV(this.entryIds)
      } else if (this.selectedTargetOption.key === 'pdf_download') {
        downloadPDF(this.entryIds)
      } else {
        if (!this.modal) {
          this.modal = new Foundation.Reveal(jQuery('#bulk-update-modal'), { closeOnClick: false })
        }
        this.initializeModalData()
        this.modal.open()
      }
    },
    closeReveal () {
      this.modal.close()
    },
    initializeModalData () {
      this.$set(this, 'phaseId', null)
      this.$set(this, 'statusId', null)
      this.$set(this, 'responsibleStaffId', '')
      this.$set(this, 'remarks', '')
    },
    update () {
      Indicator.emitShow()
      this.$http.secured.put(`/entry/view/entries/${this.selectedTargetOption.key}`, this.parameter).then(response => {
        this.$toasted.global.successRightTopSingleton({ message: this.toastMessage })
        this.statusId && this.startCartInAnimation(this.statusId)
        this.$emit('updated')
      }).finally(() => {
        Indicator.emitHide()
        this.closeReveal()
      })
    },
    startCartInAnimation (statusId) {
      const targetElementId = _.includes(this.fixedStatuses.map(status => status.id), statusId)
        ? `#display-target-${statusId}` : ''
      // #entry-entriesの要素はentryTopのentry-entriesコンポーネントをラップしているdivタグに付与されている
      targetElementId && cartInAnimation.start('#entry-entries', targetElementId)
    }
  }
}
</script>
